<section *ngIf="show" class="container-menu" >
    <div class="container-logo">
        <img [src]="logo" alt="" class="logo">
    </div>
    <ul class="container-items">
        <li class="item-menu" (click)="goTo('')" >
            INICIO
        </li>
        <li class="item-menu" (click)="goTo('domicilio')" >
            RESTAURANTES
        </li>
        <li class="item-menu" (click)="goTo('reservas')" >
            RESERVAS
        </li>
        <li class="item-menu" (click)="goTo('profile')" >
            PERFIL
        </li>
        <li *ngIf="!hasSession" class="item-menu" (click)="openLogin()" >
            INICIAR SESIÓN
        </li>
    </ul>
    <a (click)="closeMenu()" class="btn-close">X</a>
</section>